import { useEffect, useRef } from "react";
import { socketClient } from "@/services/socketClient";
import { SocketResync } from "@/model/interface/SocketConnection";

export function useSocketResync(handler: (resync: SocketResync) => void) {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    return socketClient.onResync((resync) => handlerRef.current(resync));
  }, []);
}
